import { ReduceStore } from 'flux/utils';
import moment from 'moment';
import { Record, Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

export const JOB_STATUS = {
  pending: 'pending',
  submitted: 'submitted',
  running: 'running',
  failed: 'failed',
  killed: 'killed',
  finished: 'finished',
};

const ServerJob = Record({
  id: null,
  status: '',
  name: '',
  type: '',
  startedAt: '',
  updatedAt: '',
  creator: '',
});

class PendingJob extends Record({
  id: undefined,
  config: undefined,
  submittedAt: undefined,
  creator: undefined,
  status: 'Starting',
}) {
  get name() { return this.config.name; }
  get type() { return this.config.jobType; }
  get startedAt() { return moment(this.submittedAt); }
  get updatedAt() { return moment(this.submittedAt); }
}

function processJob(rawJob) {
  return new ServerJob({
    id: rawJob.id,
    status: rawJob.status,
    name: rawJob.request.name,
    type: rawJob.request.jobType,
    startedAt: moment(rawJob.created),
    updatedAt: moment(rawJob.updated),
    creator: rawJob.request.userEmail,
  });
}

function updateJobs(oldJobs, rawJobs) {
  const newJobs = new Map(rawJobs.map(j => [j.id, processJob(j)]));
  return oldJobs.merge(newJobs);
}

class JobStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.JOB_SUBMITTED:
        return state.set(action.job.id, new PendingJob(action.job));
      case Constants.RECIEVE_RAW_JOBS:
        return updateJobs(state, action.rawJobs);
      default:
        return state;
    }
  }

  getAllJobs() {
    return this.getState().toList();
  }

  getAllChrono() {
    return this.getState().toList()
      .sortBy((j => j.startedAt))
      .reverse();
  }

  getJob(id) {
    return this.getState().get(id);
  }

  getForFilter() {
    return this.getAllChrono();
  }
}

const instance = new JobStore(AppDispatcher);
export default instance;
